import React, { useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useUserContext } from "contexts/UserContext";
import ReportPageWrapper from "components/ReportPageWrapper";

import { useIsMounted } from "hooks/useIsMounted";

import MunicipalQuestionnairePage from "pages/municipal/municipalQuestionnaire/ManagementQuestionnairePage";
import * as questionnaireSubmissionService from "api/services/questionnaireSubmissionService";
import { exportQuestionnaireToWord } from "utils/export";

/**
 * The "risk management" questionnaire page.
 *
 * @returns {React.Component} The page component.
 */
const RiskManagementQuestionnairePage = () => {
  const { year: questionnaireYear } = useParams();
  const { user: currentUser } = useUserContext();

  const mounted = useIsMounted();

  const municipalityId = currentUser?.municipalityId;

  const [questionnaireResponse, setQuestionnaireResponse] = useState(null);
  const [
    questionnaireResponseToExport,
    setQuestionnaireResponseToExport,
  ] = useState(null);

  const getQuestionnaireData = async () => {
    setQuestionnaireResponse(null);
    const response = await questionnaireSubmissionService.getRiskQuestionnaire(
      municipalityId,
      questionnaireYear
    );
    setQuestionnaireResponseToExport(response);

    if (!mounted.current) {
      return;
    }

    setQuestionnaireResponse(response.status === 200 ? "received" : null);
  };

  useLayoutEffect(() => {
    getQuestionnaireData();
  }, []);

  const headerActions =
    questionnaireResponse != null
      ? [
          {
            testId: "exportQuestionnaire",
            label: "Export",
            variant: "outlined",
            style: { width: "8rem" },
            onClick: () => {
              exportQuestionnaireToWord(
                questionnaireResponseToExport.data.questions,
                `Risk Management Questionnaire ${questionnaireYear}`
              );
            },
          },
        ]
      : null;

  return (
    <ReportPageWrapper
      title="Risk Management Questionnaire"
      headerActions={headerActions}
    >
      <MunicipalQuestionnairePage
        responseOverride={questionnaireResponse}
        dataSaved={getQuestionnaireData}
        riskManagement
      />
    </ReportPageWrapper>
  );
};

export default RiskManagementQuestionnairePage;
